import { LitElement, html, css } from 'lit'
import '../../../../bui/elements/paper'

customElements.define('k-trip-reviews', class extends LitElement{

    static styles = css`

        :host {
            display: block;
            margin-top: 4em;
        }

        :host([hidden]) {
            display: none;
        }

        b-snap-scroller {
            --size: 60%;
            --gap: 2em;
        }

        b-snap-scroller[length="1"] {
            --size: 100%;
        }

        b-snap-scroller::part(button) {
            background: var(--bgd);
            font-size: 3em;
        }

        b-snap-scroller::part(button):hover {
            background-color: var(--blue-muted);
        }

        @media (max-width: 699px) {
            b-snap-scroller {
                --size: 80%;
                --gap: 1em;
            }
        }
    `

    constructor(){
        super()
        this.data = window.tripData?.recentReviews || []
        this.hidden = this.data.length == 0
    }

    render(){return html`

        <k-h2 color="blue">Reviews</k-h2>
        <br>

        <b-snap-scroller dir=x ?buttons=${this.data.length>1} length=${this.data.length}>

        ${this.data?.map(d=>html`
            <k-review-card .data=${d}></k-review-card>
        `)}
        
        </b-snap-scroller>
    `}

})

export default customElements.get('k-trip-reviews')
